// yes, it is duplicate
export const colors = {
  light: {
    foreground: '#09090b',
    background: '#ffffff',
    'primary-foreground': '#ffffff',
    destructive: '#EF4343',
    'destructive-foreground': '#ffffff',
    accent: '#FFCC00',
    'accent-icon': '#EDBE00',
    'accent-soft': '#F5CA0020',
    'accent-foreground': '#0C0C0C',
    'accent-text': '#0C0C0C',
    'text-primary': '#1A1A1A',
    'text-secondary': '#6B6B6B',
    'text-muted': '#A0A0A0',
    positive: '#32D74B',
    'positive-soft': '#32D74B20',
    'positive-foreground': '#ffffff',
    negative: '#FF453A',
    'medal-gold': '#FFD700',
    'medal-gold-soft': '#FFD70020',
    'medal-silver': '#C0C0C0',
    'medal-silver-soft': '#C0C0C020',
    'medal-bronze': '#CD7F32',
    'medal-bronze-soft': '#CD7F3220',
    'macro-protein': '#3B82F6',
    'macro-protein-soft': '#3B82F620',
    'macro-carbs': '#F59E0B',
    'macro-carbs-soft': '#F59E0B20',
    'macro-fats': '#EC4899',
    'macro-fats-soft': '#EC489920',
    'macro-fibre': '#22C55E',
    'macro-fibre-soft': '#22C55E20',
    'macro-water': '#22C1D6',
    'macro-water-soft': '#22C1D620',
    border: '#E5E5E5',
    surface: '#FAFAFA',
    'surface-elevated': '#F0F0F0',
    'popover-foreground': '#1A1A1A',
    'muted-foreground': '#A0A0A0',
    'card-foreground': '#1A1A1A',
    'secondary-foreground': '#1A1A1A',
  },
  dark: {
    foreground: '#ffffff',
    background: '#09090b',
    'primary-foreground': '#09090b',
    destructive: '#EF4343',
    'destructive-foreground': '#ffffff',
    accent: '#FFCC00',
    'accent-icon': '#EDBE00',
    'accent-soft': '#F5CA0020',
    'accent-foreground': '#FFFFFF',
    'accent-text': '#0C0C0C',
    'text-primary': '#FFFFFF',
    'text-secondary': '#9A9A9A',
    'text-muted': '#8A8A8A',
    positive: '#32D74B',
    'positive-soft': '#32D74B20',
    'positive-foreground': '#ffffff',
    negative: '#FF453A',
    'medal-gold': '#FFD700',
    'medal-gold-soft': '#FFD70020',
    'medal-silver': '#C0C0C0',
    'medal-silver-soft': '#C0C0C020',
    'medal-bronze': '#CD7F32',
    'medal-bronze-soft': '#CD7F3220',
    'macro-protein': '#3B82F6',
    'macro-protein-soft': '#3B82F620',
    'macro-carbs': '#F59E0B',
    'macro-carbs-soft': '#F59E0B20',
    'macro-fats': '#EC4899',
    'macro-fats-soft': '#EC489920',
    'macro-fibre': '#22C55E',
    'macro-fibre-soft': '#22C55E20',
    'macro-water': '#22C1D6',
    'macro-water-soft': '#22C1D620',
    border: '#2A2A2A',
    surface: '#1A1A1A',
    'surface-elevated': '#242424',
    'popover-foreground': '#FFFFFF',
    'muted-foreground': '#8A8A8A',
    'card-foreground': '#FFFFFF',
    'secondary-foreground': '#FFFFFF',
  },
} as const;

export type Color = keyof typeof colors.dark;
